import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TTableColumn } from '@treezor/design-system';

import { TAllBeneficiaryRowType } from '@/features/beneficiaries/store/models/allBeneficiaries.model';

export function AllBeneficiariesHeaders({ headerList }: { headerList: (keyof TAllBeneficiaryRowType)[] }) {
  const { t } = useTranslation();

  const getHeaderLabel = useCallback(
    (label: keyof TAllBeneficiaryRowType): string => {
      switch (label) {
        case 'isActive':
          return t('pages.currentProfiles.beneficiaries.tables.status');
        case 'createdDate':
          return t('pages.currentProfiles.beneficiaries.tables.createdOn');
        case 'actions':
          return '';
        default:
          return t(`pages.currentProfiles.beneficiaries.tables.${label.toString()}`);
      }
    },
    [t],
  );

  return headerList.map(
    (field: keyof TAllBeneficiaryRowType): TTableColumn<TAllBeneficiaryRowType> => ({
      name: field,
      field,
      label: (
        <div className={`w-full ${['statusCode'].includes(field.toString()) ? 'text-center' : ''}`}>
          {getHeaderLabel(field)}
        </div>
      ),
    }),
  );
}
